import React, { useRef } from 'react';
import LazyLoad from 'react-lazyload';
import { MainHeader } from '../../components/Headers';
import { MainNavbar } from '../../components/Navbars';
import { AboutHome, FeaturedHome, MethodHome, ServiceHome, TechnologyHome } from '../../containers/Home';
import './styles.scss';

const scrollOptions = {
  behavior: "smooth", 
  block: "end", 
  inline: "nearest"
}

function Home(props) {

  const aboutRef = useRef();

  return (
    <div id="Home">
      <MainNavbar />
      <MainHeader 
        onClickMouse={() => aboutRef.current?.scrollIntoView(scrollOptions)}
      />
      <div ref={aboutRef}>
        <LazyLoad offset={100}>
          <AboutHome />
        </LazyLoad>
      </div>
      <LazyLoad offset={100}>
        <ServiceHome />
      </LazyLoad>
      <LazyLoad offset={100}>
        <FeaturedHome />
      </LazyLoad>
      {/* <LazyLoad offset={100}>
        <MethodHome />
      </LazyLoad> */}
      <LazyLoad offset={100}>
        <TechnologyHome />
      </LazyLoad>
    </div>
  );
}

export default Home;